import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PluralizePipe } from './pluralize.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [PluralizePipe],
  exports: [PluralizePipe],
})
export class PluralizeModule {}
